import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Mic, QrCode, Search } from 'lucide-react';
import { Logo } from '../components/Logo';
import { LegalFooter } from '../components/LegalFooter';
import { LangSelector } from '../components/LangSelector';

const BLOQUES = [
  { icon: Mic, k: 'voz' },
  { icon: QrCode, k: 'etiquetas' },
  { icon: Search, k: 'buscar' },
];

export default function Landing() {
  const { t } = useTranslation();
  return (
    <div className="landing" data-testid="landing">
      <header className="landing-top">
        <Logo endoso />
        <div className="row" style={{ gap: 12, alignItems: 'center' }}>
          <LangSelector />
          <Link className="btn ghost sm" to="/login" data-testid="landing-login">{t('landing.entrar')}</Link>
        </div>
      </header>

      <section className="landing-hero">
        <h1 className="landing-title">{t('landing.titular')}</h1>
        <p className="landing-sub">{t('landing.subtitulo')}</p>
        <Link className="btn primary op landing-cta" to="/login?m=signup" data-testid="landing-cta">{t('landing.cta')}</Link>
        <p className="muted small">{t('landing.sin_tarjeta')}</p>
      </section>

      <section className="landing-bloques">
        {BLOQUES.map(({ icon: Icon, k }) => (
          <div className="landing-bloque" key={k} data-testid={`landing-bloque-${k}`}>
            <div className="landing-ico"><Icon size={22} /></div>
            <h3>{t(`landing.b_${k}_t`)}</h3>
            <p className="muted small">{t(`landing.b_${k}_d`)}</p>
          </div>
        ))}
      </section>

      <LegalFooter />
    </div>
  );
}
